import { render, staticRenderFns } from "./SourcesTable.vue?vue&type=template&id=165b3164&"
import script from "./SourcesTable.vue?vue&type=script&lang=js&"
export * from "./SourcesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports